import { Chip } from 'primereact/chip';
import React, { MouseEvent } from 'react';

import { useToasts } from '../../../hooks/use-toasts';
import { FileAttachement } from '../../../pages/mindmap/types';
import { useMindmap } from '../../../pages/mindmap/use-mindmap';
import { downloadFileFromURL } from '../../../utils/download-file-from-url';

interface FileAttachementChipProps {
  id?: string;
  attachement: FileAttachement;
  selected: boolean;
  nodeId?: string;
}

export const FileAttachementChip = ({ id, attachement, selected, nodeId }: FileAttachementChipProps) => {
  const { showToast } = useToasts();
  const {
    contextMenu: { setActiveMenu },
    interactableMap: { positionContextMenu },
  } = useMindmap();

  const onClick = (e: MouseEvent) => {
    if (selected && nodeId) {
      positionContextMenu(e, false);
      setActiveMenu({ type: 'edit-file-attachement', nodeId, attachement });

      // prevent registration as map or node click
      e.preventDefault();
      e.stopPropagation();
    } else {
      // download file
      downloadFileFromURL(attachement.url, attachement.name);
      showToast({ severity: 'info', summary: 'File download started.', detail: attachement.name });
    }
  };

  return (
    <Chip
      id={id}
      className="attachement-chip"
      image="https://picsum.photos/200/300"
      label={attachement.name}
      onClick={onClick}
    />
  );
};
